/* Khuwabb Atelier — motion engine. No dependencies.
   Features are switched on by body classes set from Theme settings > Motion:
   kwm-smooth, kwm-split, kwm-img, kwm-px, kwm-mag, kwm-trans, kwm-progress */
(function () {
  'use strict';
  var d = document, w = window, body = d.body, html = d.documentElement;
  var off = body.getAttribute('data-animations') === 'off';
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = w.matchMedia && w.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var has = function (c) { return body.classList.contains(c); };
  var still = off || reduce;
  var KWM = w.KWM = w.KWM || {};

  /* ---------------- split text ---------------- */
  function split(el) {
    if (el.classList.contains('is-split')) return;
    var ci = 0;
    el.setAttribute('aria-label', el.textContent.replace(/\s+/g, ' ').trim());
    function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var parts = n.textContent.split(/(\s+)/), frag = d.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(d.createTextNode(' ')); return; }
            var l = d.createElement('span'); l.className = 'kws-l'; l.setAttribute('aria-hidden', 'true');
            var wd = d.createElement('span'); wd.className = 'kws-w';
            Array.prototype.forEach.call(p, function (ch) { var c = d.createElement('span'); c.className = 'kws-c'; c.style.setProperty('--ci', ci++); c.textContent = ch; wd.appendChild(c); });
            l.appendChild(wd); frag.appendChild(l);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && n.tagName !== 'BR' && !n.classList.contains('kws-l')) { walk(n); }
      });
    }
    walk(el);
    el.classList.add('is-split');
  }

  /* ---------------- reveal observer ---------------- */
  var io = null;
  function observe(root) {
    root = root || d;
    if (has('kwm-split')) root.querySelectorAll('[data-kw-split]').forEach(split);
    var els = root.querySelectorAll('[data-kw-up]:not(.is-in), [data-kw-img]:not(.is-in), [data-kw-split]:not(.is-in), .kwa-rule:not(.is-in), [data-kw-in]:not(.is-in)');
    if (still || !('IntersectionObserver' in w)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    if (!io) io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { var t = x.target.__kwT || x.target; t.classList.add('is-in'); if (t !== x.target && x.target.matches('[data-kw-up],[data-kw-split],[data-kw-in],.kwa-rule')) x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: .05 });
    /* clipped elements are invisible to IntersectionObserver, so watch their parent instead */
    els.forEach(function (e) { if (e.hasAttribute('data-kw-img') && e.parentElement) { var pe = e.parentElement; if (pe.__kwT && pe.__kwT !== e) { var sp = d.createElement('span'); sp.style.cssText = 'position:absolute;inset:0;pointer-events:none'; e.parentElement.insertBefore(sp, e); pe = sp; } pe.__kwT = e; io.observe(pe); } else io.observe(e); });
  }
  KWM.observe = observe;
  /* section numbers (N° 01, 02 ...) in page order */
  function number() { var n = 0; d.querySelectorAll('.kwa-idx').forEach(function (e) { n++; e.setAttribute('data-n', n < 10 ? '0' + n : '' + n); }); }
  number(); KWM.number = number;
  KWM.split = split;

  /* ---------------- scroll loop: scrub, parallax, progress, velocity ---------------- */
  var scrubs = [], pxs = [], vels = [], vh = w.innerHeight, lastY = w.scrollY, vel = 0, lastVel = '', prog = null, ticking = false;
  function setv(el, k, v) { var c = el.__kwv || (el.__kwv = {}); if (c[k] === v) return; c[k] = v; el.style.setProperty(k, v); }
  function collect() {
    scrubs = Array.prototype.slice.call(d.querySelectorAll('[data-kw-scrub]'));
    pxs = has('kwm-px') && !still ? Array.prototype.slice.call(d.querySelectorAll('[data-kw-px]')) : [];
    vels = still ? [] : Array.prototype.slice.call(d.querySelectorAll('[data-kw-vel]'));
  }
  function frame() {
    ticking = false;
    var y = w.scrollY, i, writes = [];
    vel += ((y - lastY) - vel) * .2; lastY = y;
    /* read phase: measure everything first so the browser lays out only once per frame */
    var vv = Math.max(-1, Math.min(1, vel / 60)).toFixed(2);
    if (vv !== lastVel) { lastVel = vv; for (i = 0; i < vels.length; i++) { var rv = vels[i].getBoundingClientRect(); if (rv.bottom > 0 && rv.top < vh) writes.push([vels[i], '--kw-vel', vv]); } }
    for (i = 0; i < scrubs.length; i++) {
      var el = scrubs[i], r = el.getBoundingClientRect(), mode = el.getAttribute('data-kw-scrub'), p;
      if (r.bottom < -vh || r.top > vh * 2) continue;
      if (mode === 'pin') { var span = r.height - vh; p = span > 0 ? -r.top / span : 0; }
      else if (mode === 'enter') { p = (vh - r.top) / (vh * .9); }
      else if (mode === 'leave') { p = -r.top / Math.max(1, r.height); }
      else { p = (vh - r.top) / (vh + r.height); }
      p = Math.max(0, Math.min(1, p));
      writes.push([el, '--p', p.toFixed(3)]);
    }
    for (i = 0; i < pxs.length; i++) {
      var e2 = pxs[i], r2 = e2.parentElement.getBoundingClientRect();
      if (r2.bottom < -200 || r2.top > vh + 200) continue;
      var sp = parseFloat(e2.getAttribute('data-kw-px')) || .15;
      writes.push([e2, '--px', Math.round(-((r2.top + r2.height / 2) - vh / 2) * sp) + 'px']);
    }
    if (prog) { var h = d.documentElement.scrollHeight - vh; writes.push([prog, '--p', h > 0 ? (y / h).toFixed(3) : '0']); }
    /* write phase */
    for (i = 0; i < writes.length; i++) setv(writes[i][0], writes[i][1], writes[i][2]);
    if (Math.abs(vel) > .5) request(); else if (vel !== 0) { vel = 0; request(); }
  }
  function request() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  w.addEventListener('scroll', request, { passive: true });
  w.addEventListener('resize', function () { vh = w.innerHeight; request(); });
  KWM.refresh = function () { collect(); request(); };


  /* ---------------- Jade: auto-reveal list items inside Khuwabb sections ---------------- */
  function autoReveal(rootEl) {
    if (!has('kj-motion') || still) return;
    (rootEl || d).querySelectorAll('.kwa :is(ul, ol):not([role="tablist"]):not([data-kj-skip])').forEach(function (list) {
      if (list.closest('[aria-modal], dialog, .kwhd, .kwft')) return;
      var items = list.children; if (items.length < 2 || items.length > 40) return;
      var k = 0;
      Array.prototype.forEach.call(items, function (li) {
        if (li.tagName !== 'LI' || li.hasAttribute('data-kw-up') || li.classList.contains('kj-rv') || li.querySelector('[data-kw-up]')) return;
        li.classList.add('kj-rv'); li.setAttribute('data-kw-in', ''); li.style.setProperty('--kj-i', k++ % 6);
      });
    });
  }
  KWM.autoReveal = autoReveal;

  /* ---------------- Jade: 3D tilt on product cards ---------------- */
  if (has('kj-tilt') && fine && !still) {
    var tEl = null, tPending = false, tx = 0, ty = 0;
    d.addEventListener('pointermove', function (e) {
      var f = e.target.closest && e.target.closest('.kwk__frame');
      if (tEl && tEl !== f) { tEl.style.removeProperty('--rx'); tEl.style.removeProperty('--ry'); tEl = null; }
      if (!f) return;
      var r = f.getBoundingClientRect(); tx = (e.clientX - r.left) / r.width - .5; ty = (e.clientY - r.top) / r.height - .5; tEl = f;
      if (!tPending) { tPending = true; requestAnimationFrame(function () { tPending = false; if (!tEl) return; tEl.style.setProperty('--rx', (tx * 10).toFixed(2) + 'deg'); tEl.style.setProperty('--ry', (ty * -8).toFixed(2) + 'deg'); }); }
    }, { passive: true });
  }

  /* ---------------- smooth wheel scrolling (desktop) ---------------- */
  if (has('kwm-smooth') && fine && !still) {
    var target = w.scrollY, cur = w.scrollY, running = false, sc = new WeakMap();
    /* CSS smooth scrolling fights a JS scroll loop, so turn it off while this is active */
    html.style.scrollBehavior = 'auto';
    function jump(y) { try { w.scrollTo({ top: y, left: 0, behavior: 'instant' }); } catch (x) { w.scrollTo(0, y); } }
    function inScrollable(t) {
      while (t && t !== body && t !== d) {
        if (t.nodeType === 1) {
          var v = sc.get(t);
          if (v === undefined) { var s = getComputedStyle(t); v = t.matches('[data-kw-noscroll], dialog, [aria-modal="true"]') || /(auto|scroll)/.test(s.overflowY + s.overflowX); sc.set(t, v); }
          if (v && (t.matches('[data-kw-noscroll], dialog, [aria-modal="true"]') || t.scrollHeight > t.clientHeight + 2 || t.scrollWidth > t.clientWidth + 2)) return true;
        }
        t = t.parentNode;
      }
      return false;
    }
    function loop() {
      cur += (target - cur) * .14;
      if (Math.abs(target - cur) < .5) { cur = target; running = false; jump(cur); return; }
      jump(cur); requestAnimationFrame(loop);
    }
    w.addEventListener('wheel', function (e) {
      if (e.ctrlKey || e.defaultPrevented) return;
      if (inScrollable(e.target)) return;
      if (html.style.overflow === 'hidden' || body.style.overflow === 'hidden') return;
      e.preventDefault();
      if (!running) { cur = w.scrollY; target = cur; }
      var dy = e.deltaMode === 1 ? e.deltaY * 32 : e.deltaY;
      target = Math.max(0, Math.min(d.documentElement.scrollHeight - vh, target + dy));
      if (!running) { running = true; requestAnimationFrame(loop); }
    }, { passive: false });
    w.addEventListener('keydown', function () { running = false; });
    d.addEventListener('pointerdown', function () { running = false; target = w.scrollY; });
  }

  /* ---------------- magnetic buttons ---------------- */
  if (has('kwm-mag') && fine && !still) {
    var magEl = null;
    d.addEventListener('pointermove', function (e) {
      var t = e.target.closest ? e.target.closest('[data-kw-mag], .kwa-btn--keep') : null;
      if (magEl && magEl !== t) { magEl.style.transform = ''; magEl = null; }
      if (!t) return;
      var r = t.getBoundingClientRect(), x = e.clientX - (r.left + r.width / 2), y = e.clientY - (r.top + r.height / 2);
      magEl = t; t.style.transition = 'transform .3s cubic-bezier(.22,.8,.2,1)'; t.style.transform = 'translate(' + (x * .18).toFixed(1) + 'px,' + (y * .25).toFixed(1) + 'px)';
    }, { passive: true });
  }


  /* ---------------- scroll progress ---------------- */
  if (has('kwm-progress')) { prog = d.createElement('div'); prog.className = 'kwp'; body.appendChild(prog); }

  /* ---------------- page transitions ---------------- */
  var tr = d.querySelector('[data-kwt]');
  if (tr && has('kwm-trans') && !still) {
    try { if (sessionStorage.getItem('kwt') === '1') { sessionStorage.removeItem('kwt'); tr.classList.add('is-entering'); setTimeout(function () { tr.classList.remove('is-entering'); }, 1300); } } catch (e) {}
    d.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]'); if (!a) return;
      var href = a.getAttribute('href') || '';
      if (a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-no-transition') || /^(#|mailto:|tel:|javascript:|sms:)/i.test(href)) return;
      var u; try { u = new URL(a.href, location.href); } catch (er) { return; }
      if (u.origin !== location.origin || (u.pathname === location.pathname && u.hash) || /\/(cart|checkout|account\/logout)/.test(u.pathname) || (w.Shopify && w.Shopify.designMode)) return;
      e.preventDefault();
      tr.classList.add('is-leaving');
      try { sessionStorage.setItem('kwt', '1'); } catch (er) {}
      setTimeout(function () { location.href = u.href; }, 720);
    });
    w.addEventListener('pageshow', function (e) { if (e.persisted) tr.classList.remove('is-leaving'); });
  }

  /* ---------------- boot ---------------- */
  function boot() { number(); autoReveal(); collect(); observe(d); request(); }
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (ev) { d.addEventListener(ev, function () { setTimeout(function () { number(); autoReveal(); collect(); observe(d); request(); }, 50); }); });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  w.addEventListener('load', function () { collect(); request(); });
  d.addEventListener('shopify:section:load', function (e) { collect(); observe(e.target); request(); });
})();
